module.exports = __webpack_public_path__ + "static/media/t3.a7ec8fea.png";